// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomStructuredText_container__zoImn","structuredTextWrapper":"CustomStructuredText_structuredTextWrapper__B1Rfd"};